import {Params} from '@angular/router';

// import {PropsMapping} from '@shared/interfaces';
import {Model} from './model';

// const propsMapping: PropsMapping = {
const propsMapping: Params = {
  id: 'configId',
  tournamentId: 'tournamentId',
  tournamentCategoryId: 'tournamentCategoryId',
  format: 'format',
  isBackdraw: 'isBackdraw',
  ageLimit: 'ageLimit',
  seats: 'seats',
  groupSize: 'groupSize',
  numberOfPlayersToMainDraw: 'numberOfPlayersToMainDraw',
  numberOfSets: 'numberOfSets',
  numberOfGames: 'numberOfGames',
  withDecisivePoint: 'withDecisivePoint',
  fastSets: 'fastSets',
  tiebreakPoints: 'tiebreakPoints',
  withTiebreakDecisivePoint: 'withTiebreakDecisivePoint',
  withMatchTiebreak: 'withMatchTiebreak',
  matchTiebreakPoints: 'matchTiebreakPoints',
  withMatchTiebreakDecisivePoint: 'withMatchTiebreakDecisivePoint',
};

export class ConfigModel extends Model {
  tournamentId!: number;
  tournamentCategoryId!: number;
  format!: string;
  isBackdraw!: boolean;
  ageLimit!: number;
  seats!: number;
  groupSize!: number;
  numberOfPlayersToMainDraw!: number;
  numberOfSets!: number;
  numberOfGames!: number;
  withDecisivePoint!: boolean;
  fastSets!: boolean;
  tiebreakPoints!: number;
  withTiebreakDecisivePoint!: boolean;
  withMatchTiebreak!: boolean;
  matchTiebreakPoints!: number;
  withMatchTiebreakDecisivePoint!: boolean;

  static getInstance(data: Params): ConfigModel {
    const model = new ConfigModel();
    for (const prop in propsMapping) {
      if (
        data[propsMapping[prop]] === undefined ||
        data[propsMapping[prop]] === null
      ) {
        continue;
      }

      (model as Params)[prop] = data[propsMapping[prop]];
    }
    return model;
  }
}
